(function () {

  // NOTE: These come from the Liquid inline script:
  // window.vpvEnabledVariantIds
  // window.vpvInitialVariantId
  // window.vpvFallbackVariantId
  // window.vpvInitialVariantEnabled

  function isVariantEnabled(variantId) {
    const ids = window.vpvEnabledVariantIds || [];
    const idNum = Number(variantId);
    const idStr = String(variantId);
    return ids.includes(idNum) || ids.includes(idStr);
  }

  function setActiveVariantInForms(variantId) {
    document.querySelectorAll('form[is="product-form"] input[name="id"][data-productid]')
      .forEach((input) => {
        input.value = variantId;
        input.disabled = false;
      });
  }

  function setVariantUrl(variantId) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function setActiveVariantGallery(variantId) {
    const container = document.getElementById('vpv-product-photos');
    if (!container) return;

    const tpl =
      document.getElementById('vpv-gallery-template-' + variantId) ||
      document.getElementById('vpv-gallery-template-default');

    if (tpl && tpl.content) {
      container.innerHTML = '';
      container.appendChild(tpl.content.cloneNode(true));
    }
  }

  function setActiveVariantInfoGrid(variantId) {
    const container = document.getElementById('vpv-product-info-grid');
    if (!container) return;

    const tpl =
      document.getElementById('vpv-product-info-grid-template-' + variantId) ||
      document.getElementById('vpv-product-info-grid-template-default');

    if (tpl && tpl.content) {
      container.innerHTML = '';
      container.appendChild(tpl.content.cloneNode(true));
    }
  }

  function vpvSetActiveVariant(variantId) {
    if (!variantId) return;
    if (!isVariantEnabled(variantId)) return;

    setActiveVariantInForms(variantId);
    setActiveVariantGallery(variantId);
    setActiveVariantInfoGrid(variantId);
    setVariantUrl(variantId);
  }

  window.vpvSetActiveVariant = vpvSetActiveVariant;

  // Click handler for ANY swatch
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.variant-swatch');
    if (!swatch) return;

    const variantId = swatch.dataset.variantId;
    if (!variantId || !isVariantEnabled(variantId)) return;

    const radio = swatch.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    vpvSetActiveVariant(variantId);
  });

  // Pack / shape pills logic
  document.addEventListener('click', (event) => {
    const pill = event.target.closest('.variant-secondary-pill');
    if (!pill) return;

    const wrapper = pill.closest('[data-color-secondary-wrapper]') ||
                    document.querySelector('[data-color-secondary-wrapper]');
    if (!wrapper) return;

    const value = pill.getAttribute('data-secondary-value');
    if (!value) return;

    wrapper.querySelectorAll('.variant-secondary-pill').forEach((p) => {
      p.classList.toggle('is-active', p === pill);
    });

    wrapper.querySelectorAll('.variant-swatch-row').forEach((row) => {
      row.style.display =
        row.getAttribute('data-secondary-row') === value ? '' : 'none';
    });

    const firstSwatch = wrapper.querySelector(
      `.variant-swatch-row[data-secondary-row="${value}"] .variant-swatch`
    );
    if (firstSwatch) {
      const variantId = firstSwatch.dataset.variantId;
      if (variantId) vpvSetActiveVariant(variantId);
    }
  });

  // Initial load sync
  document.addEventListener('DOMContentLoaded', () => {
    let activeId = null;

    // URL param
    const url = new URL(window.location.href);
    const urlVariantId = url.searchParams.get('variant');
    if (urlVariantId && isVariantEnabled(urlVariantId)) {
      activeId = urlVariantId;
    } else if (window.vpvInitialVariantEnabled) {
      activeId = window.vpvInitialVariantId;
    } else if (window.vpvFallbackVariantId) {
      activeId = window.vpvFallbackVariantId;
    }

    if (activeId) {
      vpvSetActiveVariant(activeId);

      const swatch = document.querySelector(
        `.variant-swatch[data-variant-id="${activeId}"]`
      );
      if (swatch) {
        const radio = swatch.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
      }
    }
  });
})();

